export default __webpack_public_path__ + "static/3-ccc3ab5002490d0a591552bda1985bb9.jpeg";